export const slsApiBase = process.env.REACT_APP_SLS_URL?.replace(/\/$/, '')
